/**
 * Redux store. Composes the three feature slices and exposes the
 * `RootState` / `AppDispatch` types consumed by `app/hooks.ts`.
 */

import { configureStore } from '@reduxjs/toolkit';

import checkoutReducer from '../features/checkout/checkoutSlice';
import savedCardsReducer from '../features/savedCards/savedCardsSlice';
import tokenizeReducer from '../features/tokenize/tokenizeSlice';

export const store = configureStore({
  reducer: {
    checkout: checkoutReducer,
    tokenize: tokenizeReducer,
    savedCards: savedCardsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
